import React, { useEffect, useState } from "react";
import User_Dashbaord_Common_Section from "../user_dashboard_common_section/User_Dashbaord_Common_Section";
import Header from "../../../common/header/Header";
import Footer from "../../../common/footer/Footer";
import Common_Images_Transport from "../../../common/common_imges_transport/Common_Images_Transport";
import {
  UserProfile,
  UserProfileUpdate,
} from "../../../../api/auth_api/Auth_Api";
import { User_Authentication } from "../../../../user_authentication/User_Authentication";
import PhoneInput from "react-phone-number-input";
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from "../../../../config/Config";
import Loader from "../../../../loader/Loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../../../redux/actions/userProfileActions";
import { Helmet } from "react-helmet";
import { isValidFullName } from "../../../validation/Validation";
import { countries } from "../../../../utils/countries";

const User_Dashboard_Profile = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((state) => state.user_profile);

  console.log("profile", profile);

  const [isLoading, setIsLoading] = useState(false);
  const [profileImg, setProfileImg] = useState("");
  const [nameError, setNameError] = useState("");
  // <--------- Store the User Profile -------------->
  const [user_profile, setUserProfile] = useState({
    name: "",
    email: "",
    dob: "",
    gender: "",
    birth_time: "",
    birth_place: "",
    country: "",
    address: "",
    profileImg: "",
  });
  const navigate = useNavigate();

  //  <----------- onchange Section's on the Input Feilds ------------>
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "dob") {
      const year = value.split("-")[0];
      if (year.length > 4) return; // Block input with more than 4 digit year
    }

    if (name === "name") {
      const normalizedName = value.trim().replace(/\s{2,}/g, " ");
      if (value && !isValidFullName(normalizedName)) {
        setNameError(
          "Please enter a valid Full Name (letters and spaces only, 2-50 characters).",
        );
      } else {
        setNameError("");
      }
    }

    setUserProfile((prevProfile) => ({
      ...prevProfile,

      [name]: value,
    }));
  };

  // <----------- handle File Change ------------>
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const previewUrl = URL.createObjectURL(selectedFile);
      setProfileImg(previewUrl);
      setUserProfile((prevProfile) => ({
        ...prevProfile,
        profileImg: selectedFile,
      }));
    }
  };

  // <----------  User Profile Update --------------->
  const Handle_User_Profile_Update = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const trimmedName = (user_profile.name || "")
      .trim()
      .replace(/\s{2,}/g, " ");

    if (!trimmedName || !isValidFullName(trimmedName)) {
      const message =
        "Please enter a valid Full Name (letters and spaces only, 2-50 characters).";
      toast(message);
      setNameError(message);
      setIsLoading(false);
      return;
    }

    try {
      const token = User_Authentication();
      if (!token) {
        setIsLoading(false);
        throw new Error("User token not found");
      }
      const formData = new FormData();
      formData.append("name", trimmedName);
      formData.append("dob", user_profile?.dob || "");
      formData.append("gender", user_profile?.gender || "");
      formData.append("birth_time", user_profile?.birth_time || "");
      formData.append("birth_place", user_profile?.birth_place || "");
      formData.append("country", user_profile?.country || "");
      formData.append("address", user_profile?.address || "");

      // Handle profile image if provided
      if (user_profile.profileImg) {
        formData.append("profileImg", user_profile.profileImg);
      }
      const response = await UserProfileUpdate(formData, {
        Authorization: `Bearer ${token}`,
      });
      if (response?.data?.status === true) {
        toast("Profile updated successfully");
        dispatch(fetchUserProfile());
      } else {
        toast(response?.data?.message || "Failed to update profile");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error updating profile:", error);
      toast("An error occurred while updating profile");
    }
  };

  // <------- Fetch the User Profile ------------->

  useEffect(() => {
    const getProfile = async () => {
      const result = await dispatch(fetchUserProfile());
      if (result?.unauthorized) {
        localStorage.removeItem("user_token");
        localStorage.removeItem("user_is_active");
        toast("Token Expired. Please Login Again.");
        navigate("/user-login");
      }
    };
    getProfile();
  }, [dispatch]);

  useEffect(() => {
    if (profile) {
      setUserProfile({
        name: profile?.name || "",
        email: profile?.email || "",
        dob: profile?.user_detail?.dob || "",
        gender: profile?.gender || "",
        birth_time: profile?.user_detail?.birth_time || "",
        birth_place: profile?.user_detail?.birth_place || "",
        country: profile?.user_detail?.country || "",
        address: profile?.user_detail?.address || "",
        profileImg: profile?.profile_image || "",
        mobileWithCountryCode: profile?.mobileWithCountryCode || "",
      });
      setProfileImg(
        profile?.profile_image
          ? `${IMG_BASE_URL}${profile?.profile_image}`
          : "",
      );
    }
  }, [profile]);
  localStorage.setItem("active_tabs", 1);

  return (
    <>
      <Helmet>
        {/* <title>{letest_post_details?.meta_title}</title>
                <meta name="description" content={letest_post_details?.meta_description
                    || "description"} /> */}
        <link rel="canonical" href={`${WEB_DOMAIN_KEY}user-profile`} />
        <link
          rel="alternate"
          hreflang="en-us"
          href={`${WEB_DOMAIN_KEY}user-profile`}
        />
      </Helmet>
      {/* <----------- Header section's -------------> */}
      <Header />
      {/* <---------- User Profile section's -----------> */}
      <div className="bg-[#f8f8f8] py-8">
        <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
            
          <div className="myaccount-section w-full">
            <div className="w-full">
              <div className="w-full my-10">
                <div className="w-full bg-white shadow-xl p-5">
                  <div className="my_account w-full flex space-x-5">
                    <User_Dashbaord_Common_Section />
                    <div className="flex-1">
                      <div className=" w-full">
                        {/* <h1 className="font-bold text-[24px] text-qblack mb-4">Profile</h1> */}
                        {isLoading ? (
                          <Loader />
                        ) : (
                          <form
                            action="#"
                            method="post"
                            onSubmit={Handle_User_Profile_Update}
                          >



                            
                            <div className="flex space-x-8">
                              <div className="w-full">
                                <div className="gi-login-wrap flex gi-register-half w-[100%] flex-col">
                                  {/* <h4 className="text-lg font-semibold">Update Profile Picture</h4> */}

                                  <div className="iconflexd text-center relative mb-5">
                                    <div className="columns relative w-full m-auto">
                                      <div className="circle">
                                        {profileImg ? (
                                          <img
                                            className="asdf-propic profile-pic object-cover position-top rounded-full w-[200px] h-[200px] m-auto"
                                            src={profileImg}
                                            alt="Preview"
                                          />
                                        ) : user_profile?.profileImg ? (
                                          <img
                                            className="asdf-propic profile-pic object-cover position-top rounded-full w-[200px] h-[200px] m-auto"
                                            src={`${IMG_BASE_URL}${user_profile?.profileImg}`}
                                            alt="User"
                                          />
                                        ) : (
                                          <img
                                            className=" asdf-propic profile-pic object-cover position-top rounded-full w-[200px] h-[200px] m-auto"
                                            src={
                                              Common_Images_Transport?.user_logo
                                            }
                                            alt="Default"
                                          />
                                        )}
                                      </div>
                                      
                                      <div className="absolute bottom-[5px] left-20 right-0 flex justify-center">
                                        <div className="asdf-uploadpic p-image rounded-full relative">
                                          <i className="fi-rr-camera text-[#fff] text-[18px] leading-[17px]"></i>
                                          <input
                                            className="file-upload"
                                            type="file"
                                            name="profileImg"
                                            onChange={handleFileChange}
                                            accept="image/*"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                                  <div className="h-full">
                                    <div className="input-com">
                                      <label className="input-label capitalize block  mb-2 text-qgray text-[12px] font-normal">
                                        Full Name*
                                      </label>
                                      <div className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                        <input
                                          placeholder="Full Name"
                                          value={user_profile.name || ""}
                                          name="name"
                                          onChange={handleChange}
                                          className="input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                          type="text"
                                          required
                                        />
                                      </div>
                                      {nameError ? (
                                        <p className="mt-1 text-red-500 text-xs">{nameError}</p>
                                      ) : null}
                                    </div>
                                  </div>
                                  <div className="h-full">
                                    <div className="input-com ">
                                      <label className="input-label capitalize block  mb-2 text-qgray text-[12px] font-normal">
                                        Email *
                                      </label>
                                      <div className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                        <input
                                          placeholder="Email"
                                          disabled
                                          className="w-full input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                          type="text"
                                        //    style={{ width: "300px" }}
                                          value={user_profile?.email}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                                  <div className="h-full">
                                    <div className="input-com ">
                                      <label className="input-label capitalize block  mb-2 text-qgray text-[12px] font-normal">
                                        Phone*
                                      </label>
                                      <div>
                                        <PhoneInput
                                          disabled
                                          international
                                          value={
                                            user_profile?.mobileWithCountryCode
                                          }
                                          className="w-full mb-[15px] px-[15px] bg-transparent border-[1px] border-solid border-[#eee] rounded-[5px] text-[#777] text-[14px] outline-[0] h-[50px]"
                                          placeholder="Enter phone number"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="gi-login-wrap flex gi-register-half w-[200px] flex-col">
                                    <label className="input-label capitalize block  mb-2 text-qgray text-[12px] font-normal">
                                      Date Of Birth*
                                    </label>
                                    <div className="iconflex">
                                      <i className="fi-rs-calendar text-[#303030] text-[18px] leading-[17px]"></i>
                                      <input
                                        type="date"
                                        value={user_profile?.dob || ""}
                                        name="dob"
                                        max={
                                          new Date().toISOString().split("T")[0]
                                        }
                                        onChange={handleChange}
                                        placeholder="date"
                                        className="w-full mb-[15px] px-[15px] bg-transparent border-[1px] border-solid border-[#eee] rounded-[5px] text-[#777] text-[14px] outline-[0] h-[50px]"
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="gi-login-wrap flex flex-col mb-3 gi-register-half w-full md:w-[50%] pr-3">
  <label className="input-label capitalize block mb-2 text-qgray text-[12px] font-normal">
    Gender*
  </label>

  <div className="grid w-full gap-2 grid-cols-1 md:grid-cols-3">
    {/* Male */}
    <div className="relative">
      <input
        type="radio"
        id="male"
        value="male"
        checked={user_profile?.gender == "male"}
        name="gender"
        onChange={handleChange}
        className="absolute left-[12px] top-1/2 -translate-y-1/2 peer"
      />
      <label
        htmlFor="male"
        className="inline-flex items-center gap-2 w-full px-3 py-2 text-sm text-gray-500 bg-white border border-gray-200 rounded-md cursor-pointer
        hover:bg-gray-100 hover:text-gray-600
        peer-checked:border-blue-600 peer-checked:text-blue-600 peer-checked:bg-blue-50"
      >
        <span className="text-[14px] leading-none">♂</span>
        <span>Male</span>
      </label>
    </div>

    {/* Female */}
    <div className="relative">
      <input
        type="radio"
        id="female"
        value="female"
        checked={user_profile?.gender == "female"}
        name="gender"
        onChange={handleChange}
        className="absolute left-[12px] top-1/2 -translate-y-1/2 peer"
      />
      <label
        htmlFor="female"
        className="inline-flex items-center gap-2 w-full px-3 py-2 text-sm text-gray-500 bg-white border border-gray-200 rounded-md cursor-pointer
        hover:bg-gray-100 hover:text-gray-600
        peer-checked:border-blue-600 peer-checked:text-blue-600 peer-checked:bg-blue-50"
      >
        <span className="text-[14px] leading-none">♀</span>
        <span>Female</span>
      </label>
    </div>

    {/* Other */}
    <div className="relative">
      <input
        type="radio"
        id="other"
        value="other"
        checked={user_profile?.gender == "other"}
        name="gender"
        onChange={handleChange}
        className="absolute left-[12px] top-1/2 -translate-y-1/2 peer"
      />
      <label
        htmlFor="other"
        className="inline-flex items-center gap-2 w-full px-3 py-2 text-sm text-gray-500 bg-white border border-gray-200 rounded-md cursor-pointer
        hover:bg-gray-100 hover:text-gray-600
        peer-checked:border-blue-600 peer-checked:text-blue-600 peer-checked:bg-blue-50"
      >
        <span className="text-[14px] leading-none">⚧</span>
        <span>Other</span>
      </label>
    </div>
  </div>
</div>

                                
                                <div className="input-grid mb-8">
                                  <div className="w-full">
                                    <div className="input-com ">
                                      <label className="input-label capitalize block  mb-2 text-qgray text-[12px] font-normal">
                                        Country*
                                      </label>
                                      <div className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                        <select
                                          className="w-full input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                          value={user_profile?.country || ""}
                                          name="country"
                                          onChange={handleChange}
                                        >
                                          <option value="">Select country</option>
                                          {countries.map((country, index) => (
                                            <option key={index} value={country}>
                                              {country}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="input-grid mb-8">
                                  <div className="w-full">
                                    <div className="input-com ">
                                      <label className="input-label capitalize block  mb-2 text-qgray text-[12px] font-normal">
                                        Address*
                                      </label>
                                      <div className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                        <input
                                          placeholder="your address here"
                                          className="input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                          type="text"
                                          value={user_profile?.address || ""}
                                          name="address"
                                          onChange={handleChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="asdf5 input-grid flex space-x-2.5 mb-8">
                                  <div className="h-full">
                                    <div className="input-com ">
                                      <label className="input-label capitalize block  mb-2 text-qgray text-[12px] font-normal">
                                        Birth Place*
                                      </label>
                                      <div className="input-wrapper border border-qgray-border  overflow-hidden relative ">
                                        <input
                                          placeholder="Birth Place"
                                          className="input-field placeholder:text-sm text-sm px-6 text-dark-gray  font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                          type="text"
                                          value={
                                            user_profile?.birth_place || ""
                                          }
                                          name="birth_place"
                                          onChange={handleChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="h-full">
                                    <div className="input-com ">
                                      <label className="input-label capitalize block  mb-2 text-qgray text-[12px] font-normal">
                                        Brith Time*
                                      </label>
                                      <div className="iconflex">
                                        <i className="fi-rr-clock text-[#303030] text-[18px] leading-[17px]"></i>
                                        <input
                                          type="time"
                                          value={user_profile?.birth_time || ""}
                                          name="birth_time"
                                          onChange={handleChange}
                                          placeholder="brith time"
                                          className="w-full mb-[15px] px-[15px] bg-transparent border-[1px] border-solid border-[#eee] rounded-[5px] text-[#777] text-[14px] outline-[0] h-[50px]"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>









                            <div className="action-area flex justify-between space-x-4 items-center">
                              <button
                                type="submit"
                                className="w-[164px] h-[45px] bg-[#9F2225] text-white text-sm"
                              >
                                Update Profile
                              </button>
                              {/* <button type="button"
                                                                    className="text-sm bg-gray-500 text-white h-[45px] px-5 text-qred font-semibold">Cancel</button> */}
                            </div>
                          </form>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <----------- Footer section's -------------> */}
      <Footer />
    </>
  );
};

export default User_Dashboard_Profile;
